/*
 * Copyright (c) 2019 Frontier Developments PLC.
 */

import {NavigationGuard} from 'vue-router';
import {RawLocation, Route} from 'vue-router/types/router';
import {Vue} from 'vue-property-decorator';
import store from '@/store';
import languageService from '@/services/language';
import Utils from '@/services/utils';

/**
 * Settings injection route guard.
 * This guard will check for the following items and attempt to apply them to the environment:
 * 1. token - this is the steam token which will be updated to the user session module with an infinite expiry.
 * 2. lang - this is the language setting from the game.  The language service is used to proliferate this setting.
 * 3. zoo - this is the host zoo from which the game was launched.  This will be updated in the game data.
 *
 * @param to
 * @param from
 * @param next
 */
export const settingsInjectionGuard: NavigationGuard = async (
    to: Route,
    from: Route,
    next: (to?: RawLocation | false | ((vm: Vue) => any) | void) => void,
): Promise<void> => {

    if (to.query.hasOwnProperty('token')) {
        await store.dispatch('userSessionModule/addToken', to.query.token as string);
    }

    if (to.query.hasOwnProperty('lang')) {
        languageService.setLanguage(to.query.lang as string);
    }

    if (to.query.hasOwnProperty('zoo') && Utils.isUuid4(to.query.zoo as string)) {
        await store.dispatch('gameModule/setZoo', to.query.zoo as string);
    }

    if (to.query.hasOwnProperty('balance')) {
        await store.dispatch('gameModule/setCash', +to.query.balance);
    }

    next();
};
